import React, { useState, useEffect, Fragment } from "react";
import cx from "classnames";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import AuthService from "../../pages/Authentication/auth.service";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import useAdminNotifications from "../../hooks/useAdminNotifications";

import PerfectScrollbar from "react-perfect-scrollbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleDown, faUser, faUserEdit, faBell, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { IoIosGrid, IoIosNotifications } from "react-icons/io";
import Flag from "react-flagkit";

import city3 from "../../assets/utils/images/dropdown-header/city3.jpg";
import { getFileUrl } from "../../utils/fileUtils";
import city2 from "../../assets/utils/images/dropdown-header/city2.jpg";
import user from "../../assets/utils/images/avatars/user_gen.png";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { useSelector } from 'react-redux';

import {
  DropdownToggle,
  DropdownMenu,
  Nav,
  Col,
  Row,
  Button,
  NavItem,
  NavLink,
  UncontrolledTooltip,
  UncontrolledButtonDropdown,
  UncontrolledDropdown,
  DropdownItem,
  Input,
  InputGroup,
  InputGroupText
} from "reactstrap";

library.add(
  faUser,
  faUserEdit,
  faBell,
  faCalendarAlt
);

const Topbar = () => {

  const { t, i18n } = useTranslation();
  const authData = useSelector((state) => state.authReducer.authData);
  let accessPages = [];
  let super_admin = false;
  let moduleDetails = authData?.userData?.role_details?.all_module_details;
  if (authData?.userData?.role_details?.super_admin === true) {
    super_admin = true
  } else {
    if (Array.isArray(moduleDetails)) {
      accessPages = moduleDetails.map(module => module.route);
      console.log("My Access Pages", accessPages);
    } else {
      console.log("No module details available");
    }
  }

  const userString = localStorage.getItem('user');
  const userSession = JSON.parse(userString);

  let user_type;
  if (userSession !== null) {
    user_type = userSession['user_type'];
  }

  useEffect(() => {
    setLanguageFlag(localStorage.getItem("language"));
  }, []);

  const navigate = useNavigate();
  const currentUser = authData?.userData;
  const storedUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      return null;
    }
  })();
  const adminUserId = currentUser?._id || storedUser?._id;
  const {
    notifications,
    unreadCount,
    loading: notificationsLoading,
    loadNotifications,
    markNotificationRead,
    markAllRead,
    formatTime,
  } = useAdminNotifications(adminUserId);

  const unreadNotifications = notifications.filter((n) => !n.is_read_for_admin);

  const handleNotificationClick = async (notification) => {
    await markNotificationRead(notification);
    if (notification?.redirectTo) {
      navigate(notification.redirectTo);
    }
  };

  const [logo, setLogo] = useState(localStorage.getItem("system_logo"));
  const [langFlag, setlangFlag] = useState('');
  const [active1, setActive1] = useState(false);
  const [active2, setActive2] = useState(false);
  
  // New state for date filter
  const [startDate, setStartDate] = useState('2023-09-10');
  const [endDate, setEndDate] = useState('2024-09-10');
  const [showDateFilter, setShowDateFilter] = useState(false);

  function setLanguageFlag(lang) {
    if (lang == 'en') {
      setlangFlag('GB');
      setActive1(true)
      setActive2(false)
    }
    else {
      setlangFlag('MY');
      setActive1(false)
      setActive2(true)
    }
  };

  function changeLanguage(lang) {
    console.log('language:-', lang);
    localStorage.setItem('language', lang);
    setLanguageFlag(lang);
    i18n.changeLanguage(lang);
  }

  function logOut() {
    if (localStorage.getItem('user_type') === 'users') {
      AuthService.logout();
      navigate("/user-login/customers");
      window.location.reload();
    } else {
      AuthService.logout();
      navigate("/login");
      window.location.reload();
    }
  };

  const handleDateFilterApply = () => {
    console.log('Date filter applied:', { startDate, endDate });
    // Add your date filter logic here
    setShowDateFilter(false);
  };

  return (
    <Fragment>
      <TransitionGroup>
        <CSSTransition component="div"
          className={cx("app-header header-shadow")}
          appear={true} timeout={1500} enter={false} exit={false}>
          <div>
            <div className="app-header__logo d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <img alt="BaseSystem" src={getFileUrl(logo)} style={{ width: '100px', height: 'auto', marginRight: '50px' }} className="app-logo" />
                {/* <h4 className="mb-0 text-dark fw-bold" style={{fontSize:'25px'}}>Sara Analytical Dashboard</h4> */}
              </div>
              <div className="header__pane ms-auto"></div>
            </div>
            <div
              className={cx("app-header__content", {
                // "header-mobile-open": false,
              })}>
              <div className="app-header-right d-flex align-items-center">
                

                {/* Notification Bell */}
                <div className="header-btn-lg pe-3">
                  <UncontrolledDropdown onToggle={(isOpen) => { if (isOpen) loadNotifications(); }}>
                    <DropdownToggle
                      color="link"
                      className="p-2 text-muted position-relative"
                      style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '50%',
                        background: '#f8f9fa',
                        width: '40px',
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      id="notificationTooltip"
                    >
                      <FontAwesomeIcon icon={faBell} />
                      {unreadCount > 0 && (
                        <span
                          className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                          style={{ fontSize: '0.6rem' }}
                        >
                          {unreadCount > 99 ? '99+' : unreadCount}
                        </span>
                      )}
                    </DropdownToggle>
                    <UncontrolledTooltip placement="bottom" target="notificationTooltip">
                      {t('Notifications')}
                    </UncontrolledTooltip>
                    <DropdownMenu end className="rm-pointers dropdown-menu-lg" style={{ minWidth: '360px' }}>
                      <div className="dropdown-menu-header">
                        <div className="dropdown-menu-header-inner bg-success">
                          <div className="menu-header-content text-start">
                            <div className="widget-content p-0">
                              <div className="widget-content-wrapper">
                                <div className="widget-content-left">
                                  <div className="widget-heading text-white">{t('Notifications')}</div>
                                  <div className="widget-subheading opacity-8 text-white">
                                    {unreadCount > 0
                                      ? `${unreadCount} ${t('unread')}`
                                      : t('No unread notifications')}
                                  </div>
                                </div>
                                {unreadCount > 0 && (
                                  <div className="widget-content-right">
                                    <Button size="sm" color="light" className="btn-pill" onClick={markAllRead}>
                                      {t('Mark all read')}
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="scroll-area-xs" style={{ height: "280px" }}>
                        <PerfectScrollbar>
                          <Nav vertical>
                            {notificationsLoading && (
                              <NavItem className="p-3 text-muted small">{t('Loading...')}</NavItem>
                            )}
                            {!notificationsLoading && unreadNotifications.length === 0 && (
                              <NavItem className="p-3 text-muted small">{t('No unread notifications')}</NavItem>
                            )}
                            {!notificationsLoading && unreadNotifications.map((notification) => (
                              <NavItem
                                key={notification._id}
                                className="border-bottom p-3"
                                style={{ cursor: 'pointer', background: notification.is_read_for_admin ? 'transparent' : '#f0fdf4' }}
                                onClick={() => handleNotificationClick(notification)}
                              >
                                <div className="d-flex">
                                  <div className="me-3">
                                    <div className="bg-success rounded-circle d-flex align-items-center justify-content-center"
                                      style={{ width: '35px', height: '35px' }}>
                                      <FontAwesomeIcon icon={faBell} className="text-white" size="sm" />
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <div className="small fw-bold">{notification.title}</div>
                                    <div className="text-muted small">{notification.description}</div>
                                    <div className="text-muted small">{formatTime(notification.action_time)}</div>
                                  </div>
                                </div>
                              </NavItem>
                            ))}
                          </Nav>
                        </PerfectScrollbar>
                      </div>
                      <div className="dropdown-menu-footer text-center py-2 border-top">
                        <Button
                          color="link"
                          className="text-success fw-bold text-decoration-none"
                          onClick={() => navigate('/notifications')}
                        >
                          {t('View all notifications')}
                        </Button>
                      </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>


                {/* Date Filter */}
                {/* <div className="header-btn-lg pe-3">
                  <UncontrolledDropdown>
                    <DropdownToggle 
                      color="link" 
                      className="p-2 text-muted d-flex align-items-center"
                      style={{ border: '1px solid #e0e0e0', borderRadius: '8px', background: '#f8f9fa' }}
                    >
                      <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                      <span className="small">Filter by date: {startDate} - {endDate}</span>
                    </DropdownToggle>
                    <DropdownMenu end className="p-3" style={{ minWidth: '300px' }}>
                      <div className="mb-3">
                        <label className="form-label small fw-bold">Start Date</label>
                        <Input
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          className="form-control-sm"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label small fw-bold">End Date</label>
                        <Input
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          className="form-control-sm"
                        />
                      </div>
                      <div className="text-end">
                        <Button 
                          size="sm" 
                          color="success" 
                          onClick={handleDateFilterApply}
                        >
                          Apply Filter
                        </Button>
                      </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div> */}

                

                <div className="header-dots">
                </div>

                <div className="header-btn-lg pe-0">
                  <div className="widget-content p-0">
                    <div className="widget-content-wrapper">
                      <div className="widget-content-left">
                        <UncontrolledButtonDropdown>
                          <DropdownToggle color="link" className="p-0 d-flex align-items-center">
                            <img width={28} src={user} alt="" />
                            <FontAwesomeIcon
                              className="ms-2 opacity-8"
                              icon={faAngleDown}
                            />
                          </DropdownToggle>
                          <DropdownMenu end className="rm-pointers dropdown-menu-lg">
                            <div className="dropdown-menu-header">
                              <div className="dropdown-menu-header-inner bg-info">
                                <div className="menu-header-image opacity-2"
                                  style={{
                                    backgroundImage: "url(" + city3 + ")",
                                  }} />
                                <div className="menu-header-content text-start">
                                  <div className="widget-content p-0">
                                    <div className="widget-content-wrapper">
                                      <div className="widget-content-left me-3">
                                        <img width={62} className="rounded-circle" src={user} alt="" />
                                      </div>
                                      <div className="widget-content-left">
                                        {currentUser &&
                                          <div className="widget-heading">
                                            {currentUser.name}
                                          </div>
                                        }
                                        <div className="widget-subheading opacity-8">
                                          {currentUser?.role_details?.name}
                                        </div>
                                      </div>
                                      <div className="widget-content-right me-2">
                                        <Button className="btn-pill btn-shadow btn-custom-color btn-shine" onClick={logOut}>
                                          {t('Logout')}
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="scroll-area-xs"
                              style={{
                                height: "80px",
                              }}>
                              <PerfectScrollbar>
                                <Nav vertical>
                                  <NavItem>
                                    <NavLink href={`/${user_type === 'customers' ? 'User_Profile' : 'my-profile'}`}>
                                      <FontAwesomeIcon icon={faUserEdit} className="px-2 py-0" style={{ marginBottom: "3px" }} />
                                      {t('My Profile')}
                                    </NavLink>
                                  </NavItem>
                                </Nav>
                              </PerfectScrollbar>
                            </div>
                          </DropdownMenu>
                        </UncontrolledButtonDropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  );
}

export default Topbar;